import React, { useState } from 'react';
import { Modal, message } from 'antd';
import { useParams } from 'react-router-dom';
import { theme } from 'utils/style/theme';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import iconClose from 'utils/icon/icon_close_circle.svg';
import { handleMessage } from 'utils/helper/message';
import PrimaryButton from 'components/button/PrimaryButton';
import { modelAPI } from 'apis/resource/modelAPI';
import { liveBackgroundApi } from 'apis/resource/liveBackgroundApis';
import { liveObjApi } from 'apis/resource/liveObjectApis';
import { liveIllustApi } from 'apis/resource/liveIllustApis';
import InputStyled from 'components/InputStyled';

/**
 * * 리소스 - 미니컷 등록 모달
 */

interface IProps {
  visible: {
    register: boolean;
    delete: boolean;
    zip: boolean;
    name: string;
  };
  setVisible: (e: any) => void;
  setRefresh: React.Dispatch<React.SetStateAction<boolean>>;
  refresh: boolean;
  type: string;
  projectId: string | undefined;
  data: any;
}

const CreateModal = ({
  visible,
  setVisible,
  setRefresh,
  refresh,
  type,
  projectId,
}: IProps) => {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState<string>('');

  const [loading, setLoading] = useState(false);

  /// 서버 전송
  const handleSubmit = async () => {
    if (projectId) {
      try {
        const postData = {
          live_name: inputValue,
        };
        setLoading(true);
        const url =
          type === 'live_bg'
            ? liveBackgroundApi.liveBackgroundCreate
            : type === 'live_object'
            ? liveObjApi.liveObjectCreate
            : liveIllustApi.liveIllustCreate;
        await url(projectId, postData);
        setRefresh(!refresh);
        setLoading(false);
        handleClose();
      } catch (err) {
        setLoading(false);
        handleMessage(message, 'error', 'Upload failed');
      }
    }
  };

  /// 모달 닫기
  const handleClose = () => {
    setVisible({ ...visible, register: false });
    setInputValue('');
    // 폼을 비워줘야 이미지 첨부한 것도 비워진다.
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  return (
    <CustomModal
      title={t(
        'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.live.createModal.title',
      )}
      visible={visible.register}
      onCancel={handleClose}
      footer={
        <ButtonWrapper>
          <PrimaryButton
            text={t('buttons.create')}
            height='40px'
            width='fit-content'
            bgColor={theme.colors.blue_500}
            textColor='#ffffff'
            fontWeight={theme.fontWeights.medium}
            fontSize={theme.fontSizes.normal}
            border={`1px solid ${theme.colors.blue_500}`}
            rounded='6px'
            hoverBgColor={theme.colors.blue_600}
            activeBgColor={theme.colors.blue_800}
            selectedBgColor={theme.colors.blue_700}
            onClick={handleSubmit}
            loading={loading}
            disabled={loading}
          />
        </ButtonWrapper>
      }
      closeIcon={
        <img src={iconClose} width={20} height={20} alt='icon-close' />
      }
    >
      <SectionWarpper>
        <p className='title'>
          {t(
            'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.live.createModal.name',
          )}
        </p>
        <InputStyled
          value={inputValue}
          onChange={(e) => {
            handleInputChange(e);
          }}
          maxLength={30}
        />
        <p className='length-subtext'>
          {typeof inputValue.length === 'number'
            ? `${inputValue.length}/30 characters`
            : '0/30 characters'}
        </p>
      </SectionWarpper>
    </CustomModal>
  );
};

export default CreateModal;

const CustomModal = styled(Modal)`
  .ant-modal-body {
    padding: 0;
  }
  .ant-modal-content {
    box-shadow: none;
    width: 566px;
  }
  .ant-radio-wrapper {
    span {
      font-size: ${theme.fontSizes.normal};
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0.2px;
      color: ${theme.colors.dark_500};
    }
  }
  .ant-modal-footer {
    margin-top: 10px !important;
  }
  ul {
    margin-left: 25px;
  }
  .ant-modal-close:hover {
    background-color: transparent;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
`;

const SectionWarpper = styled.div`
  & > * + * {
    margin-top: 8px;
  }
`;
